module.exports = __webpack_public_path__ + "static/media/roof-pitch.2d8c87af.png";